
import Component from '../../../assets/scripts/modules/component'
import { getCookie } from '../../../assets/scripts/utilities/simple-cookie.js'

let updateTimeout
const INTERVAL = 2500
const VISIBILITY_DELAY = 10 * 1000
const AUTOHIDE_DELAY = 20 * 1000

export default class NotificationBlockComponent extends Component {
  init () {
    this.closeButton = this.element.querySelector('.notification-block__close')
    this.progressBar = this.element.querySelector('.notification-block__progress__bar')
    this.contentID = this.element.getAttribute('data-content-id')
    this.storageName = 'notification-block-closed-' + this.contentID
    this.whatsAppButtonInContent = document.querySelector('.whatsapp-button')
    // console.log(this.whatsAppButtonInContent)

    if (!this.whatsAppButtonInContent) {
      this.element.classList.add('move-down')
    }
    if (!this.closeButton) {
      return
    }

    this.closeButton.addEventListener('click', () => this.hideButton())

    if (!sessionStorage.getItem(this.storageName)) {
      this.showComponent()
    }
  }

  showComponent () {
    // only show banner if cookiebar is dismissed
    if (getCookie(`notification-cookies-dismissed`)) {
      window.clearTimeout(updateTimeout)

      window.setTimeout(() => {
        this.element.classList.add('slide-in')
        this.autoHideComponent()
      }, VISIBILITY_DELAY)
    } else {
      this.checkForCookie()
    }
  }

  autoHideComponent () {
    this.progressBar.classList.add('in-progress')
    this.progressBar.style.transitionDuration = AUTOHIDE_DELAY / 1000 + 's'
    window.setTimeout(() => {
      this.element.classList.remove('slide-in')
    }, AUTOHIDE_DELAY)
  }

  checkForCookie () {
    window.clearTimeout(updateTimeout)
    updateTimeout = window.setTimeout(() => {
      this.showComponent()
    }, INTERVAL)
  }

  hideButton () {
    window.requestAnimationFrame(() => this.element.classList.remove('slide-in'))
    sessionStorage.setItem(this.storageName, 'true')
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.notification-block').forEach(element => {
  element.instance = element.instance || new NotificationBlockComponent(element)
}))
